export default "__VITE_ASSET__DYyRaKY8__"